import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimInvoice.Edit.IRequest;
type Response = Api.Core.ClaimInvoice.Edit.IResponse;
type Headers = Api.Core.ClaimInvoice.Edit.IHeaders;
const url = '/api/Claims/Claim/:id/Invoices';
export default async function claimInvoiceEditApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url: createPathFromRoute(url, { id: body?.claimId }),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
